import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl.js";

const API_URL = serverUrl;

export const fetchCategoryData = async (category) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/products/${category}?limit=12`,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchProductById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/products/${id}`);
  return response.data;
};

export const fetchProductsByColor = async (color, productName) => {
  const params = new URLSearchParams();
  if (color) params.append("color", color);
  if (productName) params.append("productName", productName);

  try {
    const response = await axiosInstance.get(`${API_URL}/products/name`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product by color:", error);
    throw error;
  }
};

export const fetchProductRating = async (productId) => {
  const response = await axiosInstance.get(
    `${API_URL}/products/${productId}/reviews`,
  );
  return response.data;
};

export const fetchProducts = async ({
  categoryId,
  subCategoryId,
  color,
  size,
  priceRange,
  page,
  sorting,
}) => {
  const params = new URLSearchParams();

  if (priceRange && priceRange.length > 0) {
    const { lowPrice, highPrice } = priceRange[0];

    if (lowPrice !== undefined) {
      params.append("lowPrice", lowPrice);
    }

    if (highPrice !== undefined) {
      params.append("highPrice", highPrice);
    }
  }

  if (categoryId) {
    const cleanedCategoryId = String(categoryId).trim().replace(/\s+/g, "");

    if (cleanedCategoryId && cleanedCategoryId.toLowerCase() !== "product") {
      params.append("categoryId", categoryId);
    }
  }

  if (subCategoryId) params.append("subCategoryId", subCategoryId);
  if (color) params.append("color", color);
  if (sorting) params.append("sorting", sorting);
  if (size && size.length > 0) params.append("size", size.join(","));
  if (page !== undefined) params.append("page", page);

  try {
    const response = await axiosInstance.get(`${API_URL}/products`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};
